var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29",
    "data-name": "Group 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.982,
    height: 12.477,
    viewBox: "0 0 9.982 12.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3503",
    "data-name": "Rectangle 3503",
    width: 9.982,
    height: 12.477,
    fill: "#681a69"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M4.991,0A4.99,4.99,0,0,0,0,4.942c0,3.419,4.4,7.224,4.585,7.386a.627.627,0,0,0,.812,0c.218-.162,4.585-3.967,4.585-7.386A4.99,4.99,0,0,0,4.991,0m0,11.012c-1.043-.991-3.743-3.743-3.743-6.07a3.743,3.743,0,0,1,7.487,0c0,2.308-2.7,5.079-3.743,6.07",
    transform: "translate(0 0)",
    fill: "#681a69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M5.559,3A2.184,2.184,0,1,0,7.742,5.184,2.184,2.184,0,0,0,5.559,3m0,3.119a.936.936,0,1,1,.936-.936.936.936,0,0,1-.936.936",
    transform: "translate(-0.568 -0.505)",
    fill: "#681a69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon1);
export default __webpack_public_path__ + "static/media/location-icon1.b4b48ac72fc5a3166f36b94bd046eaca.svg";
export { ForwardRef as ReactComponent };